module.exports = __webpack_public_path__ + "img/xll.6c3110dc.svg";